import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

export type LangCode = 'en' | 'es' | 'pt' | 'ko';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  readonly langs = [
    { code: 'en' as LangCode, label: 'English',   flag: 'assets/flags/us.svg' },
    { code: 'es' as LangCode, label: 'Español',   flag: 'assets/flags/es.svg' },
    { code: 'pt' as LangCode, label: 'Português', flag: 'assets/flags/pt.svg' },
    { code: 'ko' as LangCode, label: '한국어',       flag: 'assets/flags/kr.svg' },
  ];

  private _lang$ = new BehaviorSubject<LangCode>('en');
  get lang$() { return this._lang$.asObservable(); }
  get lang(): LangCode { return this._lang$.value; }

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    if (isPlatformBrowser(platformId)) {
      const saved = (localStorage.getItem('lang') as LangCode) || 'en';
      this._lang$.next(saved);
    }
  }

  setLang(code: LangCode) {
    this._lang$.next(code);
    try { localStorage.setItem('lang', code); } catch {}
  }

  getFlag(code: LangCode = this.lang) {
    return this.langs.find(l => l.code === code)?.flag ?? this.langs[0].flag;
  }
}
